export const updateNickName = function (contact, payload) {
  console.log("vuex contact属性：");
  console.log(contact);
}
export const openServiceDetail = function (contact, itemData) {

}


// WEBPACK FOOTER //
// ./src/store/actions.js